/** The approved artwork is shown through a square viewport without redrawing the logo. */
export function BrandMark() {
  return (
    <svg
      className="brand-mark"
      viewBox="324 112 600 600"
      width="44"
      height="44"
      aria-hidden="true"
      focusable="false"
    >
      <image href="/assets/brand/yishi-go.webp" width="1254" height="1254" />
    </svg>
  );
}
